import { ColumnDefinition } from 'components/Grid/types';

import { basicAuditsColumns } from 'containers/Audits/components/AuditsTable/columns';

import { withoutControls } from '../columns';

const SUBMITTED_FIELD = 'audits__dateCompleted';

const CARD_FIELDS = ['audits__name', 'audits__auditor', SUBMITTED_FIELD];

const asSubmitted = (column: ColumnDefinition): ColumnDefinition => ({ ...column, headerName: 'Submitted' });

export const entityAuditsCardColumns = withoutControls(
  CARD_FIELDS.map((field) => basicAuditsColumns.find((column) => column.field === field))
    .filter((column): column is ColumnDefinition => column !== undefined)
    .map((column) => (column.field === SUBMITTED_FIELD ? asSubmitted(column) : column))
);

export const entityAuditsPageColumns = withoutControls(basicAuditsColumns);
